export const OK_INDEX = "-200"; 
export const WARNING_INDEX = "200";
export const WIP_INDEX = "400";
export const IMPACT_INDEX = "600";
export const CRITICAL_INDEX = "800";
export const EXPIRED_INDEX = "800";
